@if (dtcTroubleData?.length>0) {
<div class="container">
  <div class="row">
    <div class="col-sm-12 col-md-8">
      <div class="heading-blue">{{dtcTroubleData[0]?.type}}</div>
      <p class="normalText">{{dtcTroubleData[0]?.typeName}}</p>
      <br>
      @if (dtcTroubleData[0]?.internalCode1) {
      <p class="normalText">{{'DTC_PAGE.internalCode1Path'|cxTranslate}}
        {{dtcTroubleData[0]?.internalCode1}}</p>
      }
      @if (dtcTroubleData[0]?.internalCode2) {
      <p class="normalText">{{'DTC_PAGE.internalCode2Type'|cxTranslate}}
        {{dtcTroubleData[0]?.internalCode2}}</p>
      }
      @if (dtcTroubleData[0]?.hexCode) {
      <p class="normalText">{{'DTC_PAGE.hexCode'|cxTranslate}}
        {{dtcTroubleData[0]?.hexCode}}</p>
      }
      @if (dtcTroubleData[0]?.spnfmi) {
      <p class="normalText">{{'DTC_PAGE.FMI'|cxTranslate}}
        {{dtcTroubleData[0]?.spnfmi}}</p>
      }
      <div class="heading-blue">{{'DTC_PAGE.product_type'|cxTranslate}}</div>
      <p class="normalText">{{dtcTroubleData[0]?.productType}}</p>
      <div class="heading-blue">{{'DTC_PAGE.publiclySharableFaultDescription'|cxTranslate}}</div>
      <p class="normalText">{{dtcTroubleData[0]?.description}}</p>
    </div>
    <div class="col-sm-12 col-md-4 mt-4">
      @if (dtcTroubleData[0]?.sheetUrl) {
      <div class="download-btn-outer">
        <a href="{{dtcTroubleData[0]?.sheetUrl}}" target="_blank" class="btn button" rel="noopener">
          {{'DTC_PAGE.downloadDocument'|cxTranslate}}
          <img src="/icons/link-grey.svg" class="icon-right" alt="">
        </a>
      </div>
      <div class="download-btn-outer">
        <a target="_blank" class="btn button back" rel="noopener" (click)="goBack()">
          <img src="/icons/link_left_white.svg" class="icon-right mr-10" alt="">
          {{'DTC_PAGE.back_button'|cxTranslate}}
        </a>
      </div>
      }
    </div>
  </div>
  @if (dtcTroubleData[0]?.overview && dtcTroubleData[0]?.overview!=0) {
  <div class="para2">
    <div class="heading-blue">{{'DTC_PAGE.overview'|cxTranslate}}</div>
    <p class="normalText" [innerHtml]="dtcTroubleData[0]?.overview| newlineToBr"></p>
  </div>
  }
  @if (dtcTroubleData[0]?.possibleCauses&&dtcTroubleData[0]?.possibleCauses!=0) {
  <div class="para3">
    <div class="heading-blue">{{'DTC_PAGE.possibleCauses'|cxTranslate}}</div>
    <p class="normalText" [innerHtml]="dtcTroubleData[0]?.possibleCauses | newlineToBr"></p>
  </div>
  }
  @if (dtcTroubleData[0]?.disclaimer&&dtcTroubleData[0]?.disclaimer!=0) {
  <div class="para4">
    <div class="heading-blue">{{'DTC_PAGE.disclaimer'|cxTranslate}}</div>
    <p class="normalText" [innerHtml]="dtcTroubleData[0]?.disclaimer | newlineToBr"></p>
  </div>
  }
  @if (dtcTroubleData[0]?.beforeYouBegin&&dtcTroubleData[0]?.beforeYouBegin!=0) {
  <div class="para5">
    <div class="heading-blue">{{'DTC_PAGE.beforeYouBegin'|cxTranslate}}</div>
    <p class="normalText" [innerHtml]="dtcTroubleData[0]?.beforeYouBegin | newlineToBr"></p>
  </div>
  }
  @if (dtcTroubleData[0]?.afterRepairsMade&&dtcTroubleData[0]?.afterRepairsMade!=0) {
  <div class="para6">
    <div class="heading-blue">{{'DTC_PAGE.afterRepairsHaveBeenMade'|cxTranslate}}</div>
    <p class="normalText" [innerHtml]="dtcTroubleData[0]?.afterRepairsMade | newlineToBr"></p>
  </div>
  }
  <br>
  @if (dtcTroubleData[0]?.dtcSteps) {
  <div class="para7">
    <p class="normalText" [innerHtml]="dtcTroubleData[0]?.dtcSteps | newlineToBr"></p>
  </div>
  }
</div>
}